import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { User } from '../identity/user.model';
import { Subject } from 'rxjs';
import { NzDrawerPlacement } from 'ng-zorro-antd/drawer';
import { IdentityService } from '../identity/identity.service';
import { RequestService } from '../identity/requests/request.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent implements OnInit {

  visible = false;
  placement: NzDrawerPlacement = 'left';
  open(): void {
    this.visible = true;
  }

  close(): void {
    this.visible = false;
  }

  rightView!: string;

  currentUser: User;
  onModifyPasswrdEventSubject: Subject<void> = new Subject<void>();

  constructor(
    private authService: AuthService,
    private router: Router,
    private identityService: IdentityService,
    private requestService: RequestService
  ) { }

  ngOnInit(): void {
    this.authService.currentUserChanged.subscribe((data: User)=> {
      this.currentUser = data;
    })
    this.identityService.currentViewChanged.subscribe((data: string)=> {
      this.rightView = data;
    })
    this.rightView = 'personalData';
  }

  onChooseAction(action: string){
    if(action){
      this.rightView = action;
      this.identityService.setCurrentView(action)
    }
  }

  logout(){
    this.authService.logout();
    this.router.navigate(['/']);
  }

  onChangePassword(){
    this.onModifyPasswrdEventSubject.next();
  }

  changeView(view_name: string = "requests") {
    this.identityService.currentViewChanged.next(view_name);
  }

  canShowRequestButton() {
    return (this.requestService.hasStatusAllowed());
  }
}
